/**
 * Import required libraries
 */
import React from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

/**
 * Import required elements
 */
import LandingRender from "./render";

/**
 * MenuList Component
 */
function LandingMenu(props) {

  const history = useHistory();

  function updateLandingPage(event, componentName) {
    history.push(`/${componentName}`);
  }

  let { lang, contactPageEnabled, presentationButtonEnabled } = props;

  return React.createElement(LandingRender, {
    lang,
    contactPageEnabled, presentationButtonEnabled,
    updateLandingPage
  });
}

/**
 * Export component
 */
// map redux state to props
export default connect(state => ({
  lang: state.locale.lang,
  contactPageEnabled: state.simtopy.contactPageEnabled,
  presentationButtonEnabled: state.simtopy.presentationButtonEnabled

}))(LandingMenu);
